import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-a46c95cc"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "invite-box"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "项目团队邀请", -1));
const _hoisted_3 = {
  class: "envelope-box"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "info"
}, "你收到一封项目团队邀请函", -1));
const _hoisted_5 = {
  class: "user-info"
};
const _hoisted_6 = ["src"];
const _hoisted_7 = {
  class: "name"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "logo",
  src: "https://s.moimg.net/dist/img/modian-logo.png"
}, null, -1));
const _hoisted_9 = {
  class: "invite-info"
};
const _hoisted_10 = {
  class: "user-info"
};
const _hoisted_11 = ["src"];
const _hoisted_12 = {
  class: "name"
};
const _hoisted_13 = {
  class: "info"
};
const _hoisted_14 = {
  class: "user-info sender-info"
};
const _hoisted_15 = ["src"];
const _hoisted_16 = {
  class: "name"
};
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "tag"
}, "项目发起人", -1));
const _hoisted_18 = {
  class: "bottom-btn"
};
const _hoisted_19 = {
  key: 0,
  class: "btn disabled"
};
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "icon"
}, null, -1));
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" 已阅读并同意《 ");
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" 》 ");
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_icon = _resolveComponent("icon");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("header", {
    class: _normalizeClass([{
      'headerIOS': $data.env.isModianIos()
    }, {
      'headerAndroid': $data.env.isModianAndroid()
    }])
  }, [_createVNode(_component_icon, {
    name: "https://p6.moimg.net/path/dst_project/1569452/202305/1216/2140/2305122140kaq1RpbPOx0vObLBoxzK7QnA8w9eYV.png",
    onClick: _cache[0] || (_cache[0] = _withModifiers($event => $options.back(), ["stop"]))
  }), _hoisted_2], 2), $data.isFirst ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, [_createElementVNode("img", {
    class: "img",
    src: _ctx.$imgUrlFilter($data.invitee_user_info.icon, 150, 150) || $data.default_img
  }, null, 8, _hoisted_6), _createElementVNode("div", _hoisted_7, _toDisplayString($data.invitee_user_info.nickname), 1)]), _createElementVNode("div", {
    class: "envelope-btn",
    onClick: _cache[1] || (_cache[1] = (...args) => $options.open && $options.open(...args))
  })]), _hoisted_8], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
    key: 1
  }, [_createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("img", {
    class: "img",
    src: _ctx.$imgUrlFilter($data.invitee_user_info.icon, 150, 150) || $data.default_img
  }, null, 8, _hoisted_11), _createElementVNode("div", _hoisted_12, _toDisplayString($data.invitee_user_info.nickname), 1)]), _createElementVNode("div", _hoisted_13, "你好，我在摩点发起一个众筹项目《" + _toDisplayString($data.pro_invitation_info.title) + "》，邀请你加入项目团队，你来吗？", 1), _createElementVNode("div", _hoisted_14, [_createElementVNode("img", {
    class: "img",
    src: _ctx.$imgUrlFilter($data.cp_info.icon, 150, 150) || $data.default_img
  }, null, 8, _hoisted_15), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", null, _toDisplayString($data.cp_info.nickname), 1), _hoisted_17])])]), _createElementVNode("div", _hoisted_18, [$data.pro_invitation_info.is_join == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_19, "已接受邀请")) : (_openBlock(), _createElementBlock(_Fragment, {
    key: 1
  }, [_createElementVNode("div", {
    class: _normalizeClass(['agreement', {
      'agree': $data.agreement_status
    }]),
    onClick: _cache[3] || (_cache[3] = (...args) => $options.agreement && $options.agreement(...args))
  }, [_hoisted_20, _hoisted_21, _createElementVNode("span", {
    class: "link",
    onClick: _cache[2] || (_cache[2] = _withModifiers((...args) => $options.jumpAgreement && $options.jumpAgreement(...args), ["stop"]))
  }, "授权协议"), _hoisted_22], 2), _createElementVNode("div", {
    class: "btn",
    onClick: _cache[4] || (_cache[4] = (...args) => $options.acceptInvite && $options.acceptInvite(...args))
  }, "同意授权并接受邀请")], 64))])], 64))]);
}